import { useAuth } from "../../context/AuthProvider";
import { Route, Routes } from "react-router-dom";
import LoadingPanel from "../../custom-components/CustomLoader";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { environment } from "../../environments/environment";
import LoginPage from "../auth/LoginPage";
import ConsoleRoutes from "../../routes/ConsoleRoutes";
import ProtectedRoute from "../../routes/ProtectedRoute";
import RedirectUnknownRoutes from "../../routes/RedirectUnknownRoutes";
import { useEffect } from "react";
import syncServiceFactory from "../../services/SyncServiceImpl";
import SocketNotification from "../../custom-components/SocketNotification";

function App() {
    const { loading, user } = useAuth();

    useEffect(() => {
        if (user) {
            const syncService = syncServiceFactory();
            syncService.connect();
            return () => {
                syncService.disconnect();
            };
        }
    }, [user]);

    if (loading) {
        return <LoadingPanel isVisible={loading} />;
    }

    return (
        <GoogleOAuthProvider clientId={environment.GOOGLE_CLIENT_ID!}>
            <SocketNotification />
            <Routes>
                <Route path="/login" element={<LoginPage />} />

                <Route element={<ProtectedRoute />}>
                    <Route path="/console/*" element={<ConsoleRoutes />} />
                </Route>

                <Route path="*" element={<RedirectUnknownRoutes />} />
            </Routes>
        </GoogleOAuthProvider>
    );
}

export default App;
